import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { guarantees } from '@/mocks/strategix';

export default function Guarantees() {
  return (
    <section id="guarantees" className="relative w-full px-5 md:px-10 py-20 md:py-28 bg-background-100/40 border-y border-background-200/70">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="Гарантии"
          title="Прозрачные условия и обязательства в договоре"
          description="Мы фиксируем все важные договорённости документально. Вы точно знаете, что получите, в какие сроки и как мы отчитываемся за бюджет."
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {guarantees.map((item, index) => (
            <Reveal key={item.title} delay={index * 80} className="h-full">
              <div
                className={`h-full p-6 rounded-lg border transition-colors ${
                  item.accent
                    ? 'bg-primary-500/10 border-primary-400/50 hover:border-primary-400'
                    : 'bg-background-100/70 border-background-200/70 hover:border-primary-400/60'
                }`}
              >
                <span
                  className={`w-12 h-12 flex items-center justify-center rounded-md ${
                    item.accent ? 'bg-accent-500/20 text-accent-300' : 'bg-primary-500/15 text-primary-300'
                  }`}
                >
                  <i className={`${item.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-5 font-heading text-base md:text-lg text-foreground-950">{item.title}</h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}